import React from "react";
import styles from "./SkeletonStyles.module.css";
import { Skeleton } from "@mui/material";

function AutomationSkeleton() {
  return (
    <div
      className={styles.smallFormPopupSkeletonWrap}
      style={{ margin: "20px" }}
    >
      <div className={styles.smallFormPopupHead}>
        <Skeleton animation="wave" variant="text" width="100px" height={25} />
      </div>
      <div className={styles.smallFormPopupHeadSplit}>
        <div className={styles.smallFormPopupHeadSplitItem}>
          <Skeleton animation="wave" variant="text" width="100%" height={50} />
        </div>
        <div className={styles.smallFormPopupHeadSplitItem}>
          <Skeleton animation="wave" variant="text" width="100%" height={50} />
        </div>
      </div>

      <div className={styles.smallFormPopupHeadSplit}>
        <div className={styles.smallFormPopupHeadSplitItem}>
          <Skeleton animation="wave" variant="text" width="100%" height={50} />
        </div>
        <div className={styles.smallFormPopupHeadSplitItem}>
          <Skeleton animation="wave" variant="text" width="100%" height={50} />
        </div>
      </div>

      <div className={styles.smallFormPopupHeadSplit}>
        <div className={styles.smallFormPopupHeadSplitItem}>
          <Skeleton animation="wave" variant="text" width="100%" height={50} />
        </div>
        <div className={styles.smallFormPopupHeadSplitItem}>
          <Skeleton animation="wave" variant="text" width="100%" height={50} />
        </div>
      </div>

      <div className={styles.smallFormPopupHeadSplit}>
        <div className={styles.smallFormPopupHeadSplitItem}>
          <Skeleton animation="wave" variant="text" width="100%" height={50} />
        </div>
        <div className={styles.smallFormPopupHeadSplitItem}>
          <Skeleton animation="wave" variant="text" width="100%" height={50} />
        </div>
      </div>
      <div className={styles.smallFormPopupHeadSplit}>
        <div className={styles.smallFormPopupHeadSplitItem}>
          <Skeleton animation="wave" variant="text" width="100%" height={50} />
        </div>
        <div className={styles.smallFormPopupHeadSplitItem}>
          <Skeleton animation="wave" variant="text" width="100%" height={50} />
        </div>
      </div>
      <div className={styles.smallFormPopupHeadSplit}>
        <div className={styles.smallFormPopupHeadSplitItem}>
          <Skeleton animation="wave" variant="text" width="100%" height={50} />
        </div>
        <div className={styles.smallFormPopupHeadSplitItem}>
          <Skeleton animation="wave" variant="text" width="100%" height={50} />
        </div>
      </div>
      <div className={styles.smallFormPopupHeadSplit}>
        <div className={styles.smallFormPopupHeadSplitItem}>
          <Skeleton animation="wave" variant="text" width="100%" height={50} />
        </div>
        <div className={styles.smallFormPopupHeadSplitItem}>
          <Skeleton animation="wave" variant="text" width="100%" height={50} />
        </div>
      </div>
      <div className={styles.smallFormPopupHeadSplit}>
        <div className={styles.smallFormPopupHeadSplitItem}>
          <Skeleton animation="wave" variant="text" width="100%" height={50} />
        </div>
        <div className={styles.smallFormPopupHeadSplitItem}>
          <Skeleton animation="wave" variant="text" width="100%" height={50} />
        </div>
      </div>
      <div className={styles.smallFormPopupHeadSplit}>
        <div className={styles.smallFormPopupHeadSplitItem}>
          <Skeleton animation="wave" variant="text" width="100%" height={50} />
        </div>
        <div className={styles.smallFormPopupHeadSplitItem}>
          <Skeleton animation="wave" variant="text" width="100%" height={50} />
        </div>
      </div>
      <div className={styles.smallFormPopupHeadSplit}>
        <div className={styles.smallFormPopupHeadSplitItem}>
          <Skeleton animation="wave" variant="text" width="100%" height={50} />
        </div>
        <div className={styles.smallFormPopupHeadSplitItem}>
          <Skeleton animation="wave" variant="text" width="100%" height={50} />
        </div>
      </div>
      <div className={styles.smallFormPopupHeadSplit}>
        <div className={styles.smallFormPopupHeadSplitItem}>
          <Skeleton animation="wave" variant="text" width="100%" height={50} />
        </div>
        <div className={styles.smallFormPopupHeadSplitItem}>
          <Skeleton animation="wave" variant="text" width="100%" height={50} />
        </div>
      </div>
      <div className={styles.smallFormPopupHeadSplit}>
        <div className={styles.smallFormPopupHeadSplitItem}>
          <Skeleton animation="wave" variant="text" width="100%" height={50} />
        </div>
        <div className={styles.smallFormPopupHeadSplitItem}>
          <Skeleton animation="wave" variant="text" width="100%" height={50} />
        </div>
      </div>
      <div className={styles.smallFormPopupHead}>
        <Skeleton animation="wave" variant="text" width="100px" height={25} />
      </div>

      <div className={styles.buttonSplit}>
        <div className={styles.smallFormPopupHead}>
          <Skeleton animation="wave" variant="text" width="100px" height={50} />
        </div>
        <div className={styles.smallFormPopupHead}>
          <Skeleton animation="wave" variant="text" width="100px" height={50} />
        </div>
      </div>
    </div>
  );
}

export default AutomationSkeleton;
